export default {
  name: "CountryTag",
  props: {
    geography: {},
  },
  data() {
    return {
    };
  },
  computed: {

  },
  mounted() {

  },

  created: function () {
  },
  components: {
  },
  methods: {

  }

};
